import { useItem } from '@/composables/item'
import { craftsmanTaskService } from '@/services/api'
import { defineStore, acceptHMRUpdate } from 'pinia'

export const useCraftsmanTaskStore = defineStore('craftsmanTask', () => {
	const { items, show, create, attach, detach, update, remove, getItem } =
		useItem<
		Api.CraftsmanTaskStatusText,
		Api.CraftsmanTaskStatusTextPostInput,
		Api.CraftsmanTaskStatusTextUpdateInput
	>(craftsmanTaskService, 'craftsman_tasks', 'CraftsmanTask', {
		options: { itemRemove: false },
	})
	return {
		items,
		show,
		create,
		attach,
		detach,
		update,
		// Loeschen ist API-seitig auf im Portal angelegte Auftraege begrenzt
		// (CraftsmanTaskPolicy::delete, hp_id === null).
		remove,
		getItem,

		// AAR-1808 "E-Mail an Beteiligte"
		previewDirectEmail: craftsmanTaskService.previewDirectEmail,
		directEmail: craftsmanTaskService.directEmail,
	}
})

if (import.meta.hot) {
	import.meta.hot.accept(
		acceptHMRUpdate(useCraftsmanTaskStore, import.meta.hot)
	)
}
